'use client';

import React from 'react';

import Script from 'next/script';

import {
  APPLE_SCRIPT_LOAD_EVENT_NAME,
  APPLE_SDK_SCRIPT_SOURCE_URL,
} from '@/modules/auth/constants';

type Props = {
  nonce: string;
};

export function InitApple({ nonce }: Props) {
  return (
    <Script
      id="apple"
      nonce={nonce}
      src={APPLE_SDK_SCRIPT_SOURCE_URL}
      strategy="lazyOnload"
      onLoad={() =>
        window?.dispatchEvent(new Event(APPLE_SCRIPT_LOAD_EVENT_NAME))
      }
      async
    />
  );
}
